import { render } from "./MapExample.vue?vue&type=template&id=1580bbe1"
import script from "./MapExample.vue?vue&type=script&lang=js"
export * from "./MapExample.vue?vue&type=script&lang=js"
script.render = render

export default script